import React from "react";

const Title = ({ title }) => {
  if (!title) return null;
  return (
    <div className="section-title">
      <h4>{title}</h4>
      <div />
    </div>
  );
};

export default Title;
